module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.form) ? _c('el-form', {
    attrs: {
      "label-position": "left"
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('check-box', {
    attrs: {
      "prop": "showAdvanced"
    },
    model: {
      value: (_vm.showAdvanced),
      callback: function($$v) {
        _vm.showAdvanced = $$v
      },
      expression: "showAdvanced"
    }
  }, [_vm._v("Advanced")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 14
    }
  }, [_c('select-data-type', {
    attrs: {
      "label": "",
      "prop": "dataType"
    },
    model: {
      value: (_vm.form.dataType),
      callback: function($$v) {
        _vm.$set(_vm.form, "dataType", $$v)
      },
      expression: "form.dataType"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 7,
      "push": 1
    }
  }, [(_vm.form.dataType === 'Number') ? _c('number-input', {
    attrs: {
      "min": 0,
      "max": 5,
      "placeholder": "Decimals",
      "prop": "decimals"
    },
    model: {
      value: (_vm.form.decimals),
      callback: function($$v) {
        _vm.$set(_vm.form, "decimals", $$v)
      },
      expression: "form.decimals"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (!(_vm.form.dataType === 'el-row' || _vm.form.dataType === 'el-col')) ? _c('el-row', [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 14
    }
  }, [_c('text-input', {
    attrs: {
      "placeholder": "Label",
      "prop": "label"
    },
    model: {
      value: (_vm.form.label),
      callback: function($$v) {
        _vm.$set(_vm.form, "label", $$v)
      },
      expression: "form.label"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 7,
      "push": 1
    }
  }, [_c('check-box', {
    attrs: {
      "prop": "required"
    },
    model: {
      value: (_vm.form.required),
      callback: function($$v) {
        _vm.$set(_vm.form, "required", $$v)
      },
      expression: "form.required"
    }
  }, [_vm._v("Required")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.form.dataType === 'select-input') ? _c('div', [_c('select-input', {
    attrs: {
      "placeholder": "List",
      "filterable": "",
      "create": "",
      "return-list": ""
    },
    model: {
      value: (_vm.form.list),
      callback: function($$v) {
        _vm.$set(_vm.form, "list", $$v)
      },
      expression: "form.list"
    }
  }), _vm._v(" "), _c('center', [_vm._v("- or -")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('text-input', {
    attrs: {
      "placeholder": "URL"
    },
    model: {
      value: (_vm.form.url),
      callback: function($$v) {
        _vm.$set(_vm.form, "url", $$v)
      },
      expression: "form.url"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.dataType === 'text-area') ? _c('html-input', {
    attrs: {
      "label": "Text",
      "prop": "label",
      "width": "528px"
    },
    model: {
      value: (_vm.form.label),
      callback: function($$v) {
        _vm.$set(_vm.form, "label", $$v)
      },
      expression: "form.label"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.dataType === 'file-upload') ? _c('text-input', {
    attrs: {
      "label": "URL",
      "prop": "url"
    },
    model: {
      value: (_vm.form.url),
      callback: function($$v) {
        _vm.$set(_vm.form, "url", $$v)
      },
      expression: "form.url"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.dataType === 'number-input') ? _c('number-input', {
    attrs: {
      "min": 0,
      "max": 2,
      "label": "Decimals",
      "prop": "decimals"
    },
    model: {
      value: (_vm.form.decimals),
      callback: function($$v) {
        _vm.$set(_vm.form, "decimals", $$v)
      },
      expression: "form.decimals"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.dataType === 'el-row') ? _c('number-input', {
    attrs: {
      "min": 0,
      "max": 24,
      "label": "Gutter",
      "prop": "gutter"
    },
    model: {
      value: (_vm.form.gutter),
      callback: function($$v) {
        _vm.$set(_vm.form, "gutter", $$v)
      },
      expression: "form.gutter"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.dataType === 'el-col') ? _c('number-input', {
    attrs: {
      "min": 0,
      "max": 24,
      "label": "Span",
      "prop": "span"
    },
    model: {
      value: (_vm.form.span),
      callback: function($$v) {
        _vm.$set(_vm.form, "span", $$v)
      },
      expression: "form.span"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAdvanced) ? _c('number-input', {
    attrs: {
      "min": 0,
      "max": 2,
      "label": "Offset",
      "prop": "offset"
    },
    model: {
      value: (_vm.form.offset),
      callback: function($$v) {
        _vm.$set(_vm.form, "offset", $$v)
      },
      expression: "form.offset"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAdvanced) ? _c('check-box', {
    attrs: {
      "label": "Disabled",
      "prop": "disabled"
    },
    model: {
      value: (_vm.form.disabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "disabled", $$v)
      },
      expression: "form.disabled"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d04cbda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/forms/FormEditor.vue
// module id = 1394
// module chunks = 0